import PropTypes from "prop-types";
import React from "react";
import OkInput from "shared/components/oknf/OkInput";
import Str from "shared/components/Str";
import _str from "shared/util/_str";

import { SCREENS } from "apps/login/util/constants";

class Login extends React.Component {
	static propTypes = {
		submitReset: PropTypes.func.isRequired,
		changeScreen: PropTypes.func.isRequired,
		username: PropTypes.string,
	};

	state = { username: this.props.username };

	_onChange = (ev) => {
		this.setState({ username: ev.target.value });
	};

	_submitReset = (ev) => {
		ev.preventDefault();

		if (this.state.username) {
			this.props.submitReset(this.state.username);
		}
	};

	_backToLogin = () => {
		this.props.changeScreen(SCREENS.LOGIN);
	};

	render() {
		const { username } = this.state;

		return (
			<form
				onSubmit={this._submitReset}
				className="oknf oknf--gray login2017-form"
			>
				<div className="login2017-form-title">
					<Str>Lost your password?</Str> <br />
					<Str>We got you.</Str>
				</div>

				<div className="passwordreset login2017-fields">
					<p className="login2017-fields-field">
						<OkInput
							name="username"
							placeholder="Username or Email"
							value={username}
							className="login2017-fields-field-input login2017-username"
							onChange={this._onChange}
							autoFocus={process.env.PLATFORM === "desktop"}
						/>
					</p>
				</div>

				<div className="login2017-actions">
					<input
						type="submit"
						value={_str("Reset Password")}
						className="login2017-actions-button"
					/>
				</div>
			</form>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/apps/login/components/screens/PasswordReset.jsx